import type { FaireProductEntity } from "../../entity_types/product";

export const p_kz7renwcry: FaireProductEntity = {
  token: "p_kz7renwcry",
  type: "product",
  name: "I Smell Snow Sweatshirt - Heather Dust",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/48eb016c28e627026f46af5eb70ca35fe00ec3f681956e4fd13e8fd9a40f2f45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d3155fade8e6e7eb236ee6984481198847999a06ea9859b07ae1b0fce4b63bc.jpeg",
    "https://cdn.faire.com/fastly/71b4aea83fb89fb1e7342e9fe009129e7962a8409739e37b7ab90b9a282c5749.jpeg",
    "https://cdn.faire.com/fastly/0af18aff03c082b315778ef0315b59b31f44a137ca81cce4f3b9e2aa3bdfd271.jpeg",
  ],
  priceDollars: 35.83,
  description:
    "Our I Smell Snow graphic sweatshirt is the perfect gift for any winter and snow lover or Gilmore Girls fan! This crew-neck pullover is made from super soft cotton/fleece blend, making it warm and cozy to wear to Friday night dinners, a Stars Hollow inspired town meeting, Luke's Diner, or anywhere chilly this holiday season. Show your love for all things Rory and Lorelai with this cute top!\n\nMaterial: 52% Airlume Combed and Ring-Spun Cotton, 48% Polyester Fleece\nColor: Heather Dust\nFit: Unisex\nBrand: Bella + Canvas\nDesign: I Smell Snow\nCare Instructions: Machine wash cold inside out, gentle cycle with like colors. Hang to dry.",
  tags: [],
  msrpDollars: 71.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:33:32.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
